const SET_NOTIFICATION_ORDER_INTERVAL = "SET_NOTIFICATION_ORDER_INTERVAL";
const CLEAR_NOTIFICATION_ORDER_INTERVAL = "CLEAR_NOTIFICATION_ORDER_INTERVAL";
const NotificationOrderIntervalSymbols = {
  SET_NOTIFICATION_ORDER_INTERVAL,
  CLEAR_NOTIFICATION_ORDER_INTERVAL,
};
export default NotificationOrderIntervalSymbols;
